/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Siddharth Jha",
  title: "I'm Siddharth",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 and Competitive Programmer 💻 having an experience of building interactive and intuitive web applications."
  ),
  resumeLink:
    "https://drive.google.com/drive/folders/1zxAwcQ1GCFVIjduQxDO1wSVmbXYmSrqN", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/siddharthjha387",
  linkedin: "https://www.linkedin.com/in/siddharth-jha73/",
  gmail: "siddharthjha3901@gmail.com",
  instagram: "https://www.instagram.com/siddharth_jha387/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "I AM A FULL STACK DEVELOPER EXCELLING IN FRONTEND WHO WANTS TO EXPLORE EVERY TECH STACK. I ALSO LOVE TO BRAINSTORM AND SOLVE COMPLEX PROBLEMS.",
  skills: [
    emoji(
      "⚡ Developing highly interactive and optimized Front end / User Interfaces for your web and mobile applications"
    ),
    emoji(
      "⚡Creating robust and efficient back-end systems to power your applications."
    ),
    emoji(
      "⚡ Solving complex problems related to data structures and algorithms"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "gitlab",
      fontAwesomeClassname: "fab fa-gitlab"
    },
    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName:
        "Netaji Subhash University of Technology East Campus (formerly AIACTR)",
      logo: require("./assets/images/nsut_east_campus_logo.jpeg"),
      subHeader: "Bachelor of Technology in Electronics and Communication",
      duration: "Jul 2019 - Jul 2023",
      desc: "Core member of the technical club of the college, Innogeeks. Actively hosted and participated in various events and workshops."
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Front-End Developer",
      company: "Josh Technology Group",
      companylogo: require("./assets/images/Josh.jpeg"),
      date: "Jan 2023 – Present",
      descBullets: [
        "Implemented dynamic attachment creation with AWS S3 integration for audio-type questions in Angular. Utilized unique S3 URLs for GET, PUT, and PATCH operations, enabling seamless updating of user audio responses by editing attachments and re-uploading new audio response to the existing S3 URL",
        "Implemented dynamic question modification functionality allowing administrators to alter questions in AI-generated papers, alongside a secure one-time link feature for seamless access.",
        "Delivered a feature that allows sharing question banks of specific subjects among different organizations",
        "Technologies Used – React, Redux, Typescript, JavaScript, Vite, React hook form, Material UI, HTML5, CSS3, Angular 16, Angular material"
      ]
    },
    {
      role: "Teaching Assistant",
      company: "Coding Ninjas",
      companylogo: require("./assets/images/codingninjas.webp"),
      date: "Sep 2022 – Dec 2022",
      descBullets: [
        "Taking doubt sessions, debugging codes and helping students in their various projects.",
        "Solved 400+ doubts with 4.9-star rating.",
        "Technological stack: C++ and Data Structure and Algorithms."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Narayan Marine Tech Private Limited",
      companylogo: require("./assets/images/narayan.jpg"),
      date: "Jan 2022 – May 2022",
      descBullets: [
        "Led a team of 3 to build client management web application to create, view, update and delete client invoices.",
        "Created an admin and user log-in with complete registration and authorization",
        "Technological Used – MonogoDB, Node JS, Express JS"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Innovate India Coding Championship 2022 Finalist",
      subtitle:
        "Innovate India Coding Championship 2022 Round 3: All India Rank 111.",
      image: require("./assets/images/iicc.jpeg"),
      imageAlt: "IICC logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/10Bm1cWxPi44208-lypbDHzxsXeDurApG/view"
        }
      ]
    },
    {
      title: "Leetcode",
      subtitle:
        "Ranked under top 5% at LeetCode which ranks among the top sites for Coding Enthusiast. Highest rating of 1860 with Knight Badge",
      image: require("./assets/images/leetcode.png"),
      imageAlt: "Leetcode Logo",
      footerLink: [
        {
          name: "Visit Profile",
          url: "https://leetcode.com/u/siddharth153/"
        }
      ]
    },

    {
      title: "TCS CodeVita",
      subtitle:
        "Secured 3542 rank in TCS CodeVita Season 10 Round 1 among 100000+ participants.",
      image: require("./assets/images/codevita.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/13lTPdwaY9YzPn0QooyzAVyXjL12u6D-B/view"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+92-0000000000",
  email_address: "siddharthjha3901@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
